(function(){
  function setup(root){
    if(root.__lpScroll)return;root.__lpScroll=1;
    var ul=root.querySelector('.lp-tl__steps');if(!ul)return;
    var steps=ul.querySelectorAll('.lp-tl__step');
    root.classList.add('is-js');
    var tick=false;
    function update(){
      tick=false;
      var vh=window.innerHeight,trig=vh*0.55,r=ul.getBoundingClientRect();
      var p=(trig-r.top-10)/Math.max(1,r.height-20);
      p=Math.max(0,Math.min(1,p));
      ul.style.setProperty('--lp-prog',p);
      steps.forEach(function(s){
        var t=s.getBoundingClientRect().top+10;
        s.classList.toggle('is-active',t<=trig);
      });
    }
    function req(){if(!tick){tick=true;requestAnimationFrame(update);}}
    window.addEventListener('scroll',req,{passive:true});
    window.addEventListener('resize',req);
    update();
  }
  function init(){document.querySelectorAll('.lp-tl').forEach(setup);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();